export default __webpack_public_path__ + "static/media/express.d78a7a0c.png";